import React from 'react';
import PropTypes from 'prop-types';

const AuthConfirmModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-pl_bg_light_3 p-6 rounded-lg shadow-xl max-w-md w-full">
        <h2 className="text-lg font-semibold text-pl_txt_dark_5 mb-4">Authentication Required</h2>
        <p className="text-pl_txt_dark_4 mb-6">
          You need to be authenticated to translate documents. Please login or sign up for free.
        </p>
        <div className="flex justify-center space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-full bg-gray-200 text-pl_txt_dark_5 hover:bg-gray-300"
          >
            No, just browsing
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-full bg-pl_prim_color_1 text-white hover:bg-opacity-90"
          >
            Ok, login to translate
          </button>
        </div>
      </div>
    </div>
  );
};

AuthConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default AuthConfirmModal;
